export const self_order_label_url: string = "self_order_label";
